export class PhicubeResponse<T = any>  {
  data: T;
  status: number;
}